import { render, staticRenderFns } from "./LegalSiteArticle.vue?vue&type=template&id=7fac0870"
import script from "./LegalSiteArticle.vue?vue&type=script&lang=js"
export * from "./LegalSiteArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports